import Vue from 'vue';
import VueI18n from 'vue-i18n';
import merge from 'lodash/merge';
import elementEn from 'element-ui/lib/locale/lang/en';
import elementJp from 'element-ui/lib/locale/lang/ja';
import elementCn from 'element-ui/lib/locale/lang/zh-CN';
import elementTw from 'element-ui/lib/locale/lang/zh-TW';
import ElementLocale from 'element-ui/lib/locale';


Vue.use(VueI18n);

async function langGetter(lang) {
    let results = {};
    if (lang === 'cn') {
        results = await Promise.all([
            import('CommonMessages/account-user-settings/cn.json'),
            import('CommonMessages/analytics-homepage/cn.json'),
            import('CommonMessages/analytics-snap-business/cn.json'),
            import('CommonMessages/common-errorcode/cn.json'),
            import('CommonMessages/common-country/cn.json'),
            import('CommonMessages/common-patent/cn.json'),
            import('CommonMessages/common-province/cn.json'),
            import('CommonMessages/common-product/cn.json'),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import('CommonMessages/account-user-settings/tw.json'),
            import('CommonMessages/analytics-homepage/tw.json'),
            import('CommonMessages/analytics-snap-business/tw.json'),
            import('CommonMessages/common-errorcode/tw.json'),
            import('CommonMessages/common-country/tw.json'),
            import('CommonMessages/common-patent/tw.json'),
            import('CommonMessages/common-province/tw.json'),
            import('CommonMessages/common-product/tw.json'),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import('CommonMessages/account-user-settings/en.json'),
            import('CommonMessages/analytics-homepage/en.json'),
            import('CommonMessages/analytics-snap-business/en.json'),
            import('CommonMessages/common-errorcode/en.json'),
            import('CommonMessages/common-country/en.json'),
            import('CommonMessages/common-patent/en.json'),
            import('CommonMessages/common-province/en.json'),
            import('CommonMessages/common-product/en.json'),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import('CommonMessages/account-user-settings/jp.json'),
            import('CommonMessages/analytics-homepage/jp.json'),
            import('CommonMessages/analytics-snap-business/jp.json'),
            import('CommonMessages/common-errorcode/jp.json'),
            import('CommonMessages/common-country/jp.json'),
            import('CommonMessages/common-patent/jp.json'),
            import('CommonMessages/common-province/jp.json'),
            import('CommonMessages/common-product/jp.json'),
        ]);
    }
    const data = results.reduce((obj, data) => merge(obj, data), {});
    return { [lang]: data };
}

let i18n;

/**
 * 获取语言包
 * @param {*} language 当前语言
 * @returns VueI18n instance
 */
export const getI18n = async (locale) => {
    if (!i18n) {
        const translation = await langGetter(locale);
        const elementUi = { en: elementEn, jp: elementJp, cn: elementCn, tw: elementTw };
        const messages = merge({}, elementUi, translation);
        i18n = new VueI18n({
            locale,
            messages,
            fallbackLocale: 'en',
        });
        ElementLocale.i18n((key, value) => i18n.t(key, value));
    }
    return i18n;
};
